<app-navbar
  [headerText]="'Silinmələr'"
  [buttons]="navButtons"
  [dataLoading]="dataLoading()"
></app-navbar>

<div class="container-fluid px-3 mt-6">
  <ag-table
    [colDefs]="columnDefs"
    [tableData]="tableData"
    [tableClass]="'ag-theme-alpine'"
    [tableHeight]="'calc(100vh - 80px)'"
    (rowClicked)="openTransaction($event.data)"
  ></ag-table>
</div>
